import { render, staticRenderFns } from "./TestimoniosAdmin.vue?vue&type=template&id=59453495&scoped=true&"
import script from "./TestimoniosAdmin.vue?vue&type=script&lang=js&"
export * from "./TestimoniosAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TestimoniosAdmin.vue?vue&type=style&index=0&id=59453495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59453495",
  null
  
)

export default component.exports